import {CommonModule, CurrencyPipe} from '@angular/common';
import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {
    DxChartModule,
    DxPieChartModule
} from 'devextreme-angular';
import {
    AccessType,
    AppointmentAgingScoreExportQuery,
    AppointmentAgingScoreQuery,
    AppointmentAgingTrendingQuery,
    AppointmentsClient,
    AuthService,
    IMyScoreShiftQuery,
    ITrendingQuery,
    PermissionType,
} from "@services";
import { BehaviorSubject, } from "rxjs";
import {ScoreDashboardComponent} from "../../../../components/library/score-dashboard/score-dashboard.component";

export function appointmentAgingPalette(): Record<string, string> {
    const getColor = (name: string) => getComputedStyle(document.body).getPropertyValue(name).trim();

    return {
        ["Checked In (<24)"]: getColor('--bs-info'),
        ["Checked In (>24)"]: getColor('--bs-danger'),
        ["Completed"]: getColor('--bs-success'),
    };
}

@Component({
    selector: 'app-appointment-aging-score',
    imports: [CommonModule, DxPieChartModule, DxChartModule, ScoreDashboardComponent],
    providers: [CurrencyPipe],
    templateUrl: './appointment-aging-score.component.html',
})
export class AppointmentAgingScoreComponent implements OnInit, OnDestroy {
    private appointmentsClient = inject(AppointmentsClient);
    protected authService = inject(AuthService);

    protected readonly PermissionType = PermissionType;
    protected readonly AccessType = AccessType;

    palette: Record<string, string> = {};

    private readonly dateRange$ = new BehaviorSubject<[Date, Date]>([new Date(), new Date()]);

    loadScoreData = (query: IMyScoreShiftQuery) => {
        return this.appointmentsClient.getAppointmentAgingScore(new AppointmentAgingScoreQuery(query));
    }

    loadTrendingData = (query: ITrendingQuery) => {
        return this.appointmentsClient.getAppointmentAgingTrending(new AppointmentAgingTrendingQuery(query));
    }

    ngOnInit(): void {
        this.palette = appointmentAgingPalette();
    }

    ngOnDestroy(): void {
        this.dateRange$.complete();
    }

    exportData = (from: Date, to: Date,) => {
        const query = new AppointmentAgingScoreExportQuery({from, to});
        return this.appointmentsClient.exportAppointmentAging(query);
    }

    onDateRangeChanged(range: [Date, Date]) {
        this.dateRange$.next(range);
    }
}
